/**
 * Journal categories: frontmatter is written in whichever language the entry
 * was drafted in ("Research", "Réflexion", "Analyse"); the UI shows them in
 * the UI language. Locale keys `journal.categories.<key>` win when present;
 * the table below is the fallback. Shared by the journal index and the
 * homepage list so the two never disagree.
 */
const CATEGORY_KEYS = {
	research: "research",
	recherche: "research",
	réflexion: "reflection",
	reflexion: "reflection",
	reflection: "reflection",
	analyse: "analysis",
	analysis: "analysis",
	notes: "notes",
	note: "notes",
};

const CATEGORY_FALLBACK = {
	en: { research: "Research", reflection: "Reflection", analysis: "Analysis", notes: "Notes" },
	fr: { research: "Recherche", reflection: "Réflexion", analysis: "Analyse", notes: "Notes" },
};

const titleCase = (s) =>
	String(s || "")
		.replace(/[-_]+/g, " ")
		.replace(/\b\p{L}/gu, (c) => c.toUpperCase());

/** Canonical key ("research", "reflection", …) of a category label in any language, or null. */
export const categoryKey = (raw) =>
	CATEGORY_KEYS[
		String(raw || "")
			.trim()
			.toLowerCase()
	] || null;

/**
 * A category label in the UI language: the locale key when present, else the
 * built-in table, else the raw label title-cased.
 * @param {string} raw
 * @param {(key: string) => string} t i18n lookup
 * @param {string} lang
 */
export const categoryLabel = (raw, t, lang) => {
	if (!raw) return "";
	const key = categoryKey(raw);
	if (!key) return titleCase(raw);
	const localeKey = `journal.categories.${key}`;
	const v = t(localeKey);
	if (v && v !== localeKey) return v;
	return (CATEGORY_FALLBACK[lang] || CATEGORY_FALLBACK.en)[key] || titleCase(raw);
};
